import * as React from 'react';
const SvgRelevantContent = (props) => (
  <svg viewBox="0 0 124 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M102.193 41.447a29.847 29.847 0 0 1 1.278 8.68c0 16.49-13.304 29.858-29.717 29.858-11.772 0-21.942-6.879-26.754-16.848M46.118 40.572c3.807-11.687 14.856-20.145 27.894-20.145 4.898 0 9.52 1.19 13.577 3.31"
      stroke="#000"
      strokeWidth={3.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M88.055 44.075a14.799 14.799 0 0 1 1.298 6.082c0 8.236-6.671 14.938-14.877 14.938a14.734 14.734 0 0 1-9.829-3.744M84.941 39.484a15.548 15.548 0 0 0-4.298-2.798A16.605 16.605 0 0 0 74 35.316c-4.867 0-9.204 2.058-12 5.256M88.636 35.678 74.25 50.08M107.14 17.154l-2.215-14.876L92.67 14.546a17.563 17.563 0 0 0-4.94 14.99l.912 6.135 6.128.914a17.515 17.515 0 0 0 14.974-4.946l12.255-12.268-14.859-2.217ZM15.327 29.038c0 5.84 4.379 10.57 9.772 10.57 5.394 0 9.773-4.736 9.773-10.57 0-5.833-4.379-10.568-9.773-10.568-5.393 0-9.772 4.735-9.772 10.568ZM11.9 57.754V89.81l1.487 28.467"
      stroke="#000"
      strokeWidth={3.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9 90.106H9.653C5.428 90.106 2 86.674 2 82.444V57.498c0-6.428 5.209-11.642 11.63-11.642h56.12l-.237 1.796c-.67 5.041-4.78 8.926-9.849 9.29L38.3 58.483v31.323l-1.48 28.473M25.1 89.805v28.473"
      stroke="#000"
      strokeWidth={3.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgRelevantContent;
